import React, { Component } from "react"
import PropTypes from "prop-types"
import { Button, FormControl, Table } from "react-bootstrap"
import { browserHistory } from "react-router"

import { Row, Col } from "react-bootstrap"
import moment from "moment"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import { blockingFetchService } from "../../../lib/blockingFetch"
import SimpleCardRow from "../../fragments/SimpleCardRow"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import AlertModal from "../../fragments/AlertModal"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import SimpleCheckboxRow from "../../fragments/SimpleCheckboxRow"
import { Link } from "react-router"

class JournalEntryCard extends Component {

  authenticated = new Authenticated()
  isAdminOrAccountant = this.authenticated.isAdmin() || this.authenticated.isAccountant()

  state = {
    shouldReverse: false,
    running: false,
    success: false,
    error: null,
    comments: '',
  }

  confirmReverseJournal = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { journalEntries, loadData } = this.props,
    { transactionId, transactionDate } = journalEntries[0],
    { comments } = this.state

    blockingFetchService(
      accessToken => apiServerApi.reverseJournalEntry(accessToken, transactionId, transactionDate, comments),
      _ => {
        this.setState({ success: true })
        loadData()
        setTimeout(this.closeReverseJournalForm, 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  commentsChanged = comments => this.setState({ comments })

  closeReverseJournalForm = () => this.setState({ shouldReverse: false })

  shouldDisableDelete = ({ reversed, manualEntry }) => reversed || !manualEntry

  renderDeletionConfirmContent = () => {

    const { running, success, error, comments } = this.state
    return (
      <div>
        <label>Comments (Optional)</label>
        <FormControl componentClass="textarea"
          value={ comments } id='comments' placeholder="Enter text"
          onChange={e => this.commentsChanged(e.target.value)}
        />
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderButtonToolbar = item => {

    if(!this.isAdminOrAccountant) return null
    return (
      <div className='align-right'>
        <Button bsStyle="danger" onClick={() => this.setState({ shouldReverse: true })}
          disabled={ this.shouldDisableDelete(item) }>
          <FontAwesome name='rotate-left' /> Reverse
        </Button>

        <Button bsStyle="success" onClick={() => browserHistory.push('/journalentries/create')}
          className="ml-10">
          <FontAwesome name='plus-circle' /> New Journal Entry
        </Button>
      </div>
    )
  }

  getAccountLink = (id, name, glCode) => {

    let link = ''
    if (id && name) {
      link = <Link to={`/glaccounts/${id}/detail`} title="View">
        { `${ name } (${ glCode })` }
      </Link>
    }
    return link
  }

  getGLAccountById = (glAccountId, glAccounts) => glAccounts.find(item => item.fineractId === glAccountId)

  renderTh = name => <th className='align-center v-center'>{ name }</th>

  renderTd = content => <td className='align-center v-center'>{ content }</td>

  renderDebitsCredits = (items, glAccounts) => {

    const details = items.map(({ debitsFormatted, creditsFormatted, glAccountId }, index) => {

      const glAccount = this.getGLAccountById(glAccountId, glAccounts)
      return <tr key={`debit-${index}`}>
        { this.renderTd(glAccount ? <small>{ glAccount.type }</small> : '') }
        { this.renderTd(glAccount ? this.getAccountLink(glAccount.id, glAccount.name, glAccount.glCode) : '') }
        { this.renderTd(debitsFormatted) }
        { this.renderTd(creditsFormatted) }
      </tr>
    })

    return <Table striped condensed hover responsive>
      <thead>
        <tr>
          { this.renderTh('Type') }
          { this.renderTh('Account') }
          { this.renderTh('Debit') }
          { this.renderTh('Credit') }
        </tr>
      </thead>
      <tbody>
        { details }
      </tbody>
    </Table>
  }

  showItem = (items, glAccounts) => {

    const firstItem = items[0],
    { transactionDate, transactionId, currencyCode, comments, reversed, createdOnFormatted } = firstItem

    return (
      <Col md={8} className='detail-content'>

        <h2 className={ reversed ? 'red' : 'blue' }>Transaction { transactionId }
          { reversed ? <span> <small className="red">(reversed)</small></span> : '' }
        </h2>

        <SimpleCardRow name='Transaction Date' value={ moment(transactionDate).format('LL') } />
        <SimpleCardRow name='Currency Code' value={ currencyCode } />
        <SimpleCheckboxRow text='Is Reversed' value={ reversed } />
        <SimpleCardRow name='Comments' value={ comments ? comments : '-' } />
        <SimpleCardRow name='Created On' value={ createdOnFormatted } className='gray font-size-13' />

        { this.renderDebitsCredits(items, glAccounts) }

        { this.renderButtonToolbar(firstItem) }
      </Col>
    )
  }

  render() {

    const { journalEntries, glAccounts } = this.props
    if (!journalEntries.length) return null

    const data = [{ url: '/accounting', title: 'Accounting' }, { url: '/journalentries', title: 'Journal entries' }],
    { transactionId } = journalEntries[0],
    { shouldReverse, running } = this.state

    return (
      <div>
        <CustomBreadCrumb activeText={ transactionId } data={ data } />

        <Row>
          <Col md={4} className="align-center">
            <FontAwesome name="random" size="3x" className="detail-icon" />
          </Col>
          { this.showItem(journalEntries, glAccounts) }
        </Row>

        <AlertModal
          show={ shouldReverse }
          title={ "Reverse journal entry: " + (transactionId ? transactionId : '') }
          body={ this.renderDeletionConfirmContent() }
          bsStyle="danger"
          close={ this.closeReverseJournalForm }
          confirm={ this.confirmReverseJournal }
          proceedText="Confirm"
          disabled={ running }
        />
      </div>
    )
  }
}

JournalEntryCard.propTypes = {
  journalEntries: PropTypes.array.isRequired,
  glAccounts: PropTypes.array.isRequired,
}

export default JournalEntryCard



// WEBPACK FOOTER //
// ./src/components/Accounting/JournalEntries/Card.js